import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../../Liracrypt/liracrypt";

const AngelaIconMultiR1C = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [chartData, setChartData] = useState();
  useEffect(() => {
    if (props.api) {
      liracrypt.get(props.api, props.urlData).then(response => {
        if (!response.data.data[props.divId]) {
          return;
        }
        setChartData({ config: response.data.data[props.divId].config });
      }).catch(err => {
        console.log(err);
      })
    } else if (props.config) {
      setChartData({ config: props.config });
    }
  }, [props?.config]);
  // useEffect(() => {
  //   if (props.config) {
  //   }
  //   return () => {};
  // }, [props?.config]);

  // let dataBlocks = props.config.dataBlocks;
  // let headerBlocks = props.config.headerBlocks;

  return (
    <div>
      {chartData?.config ? (
        <>
          <div id={props.divId} style={chartData.config.chartDiv.style}>
            <Row>
              <Col style={{ width: "30%" }}>
                <img
                  style={chartData.config.headerImg.style}
                  src={chartData.config.headerImg.img}
                  height="50px"
                  width="50px"
                />
              </Col>
              <Col style={{ width: "70%" }}>
                <Row>
                  {chartData.config.headerBlocks.map((headerBlock) => {
                    return (
                      <Row style={{ width: "100%" }}>
                        <div style={headerBlock.val.style}>
                          {`${headerBlock.val.text} `}
                        </div>
                      </Row>
                    );
                  })}
                </Row>
              </Col>
            </Row>

            <hr style={chartData.config.divider.style}></hr>

            

            <div>
              {chartData.config.dataBlocks.map((dataBlock) => {
                return (
                  <Row>
                    <Col style={{ width: "65%" }}>
                      <div style={dataBlock.param.style}>
                        {`${dataBlock.param.text} `}
                      </div>
                    </Col>
                    <Col style={{ width: "35%" }}>
                      <div style={dataBlock.val.style}>
                        {`${dataBlock.val.text} `}
                      </div>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default AngelaIconMultiR1C;
